module.exports = __webpack_public_path__ + "img/next.cad1bf8c.svg";